import {MI} from "../init";
import MadnesTween from "../libs/mi/MadnesTween.js";

/**
 * @constructor
 * @param {Game} game
 * @param {ResultController} resultController
 * @param {ServerResult} serverResult
 * @param {SymbolsManager} symbolsManager
 * @returns {WinControl}
 */

export default function WinControl(game, resultController, serverResult, symbolsManager) {

    /** @type {Game}  */
    this._game = game;

    /** @type {GameGroups} */
    this._groups = game.groups;

    /** @type {GameAssets} */
    this._assets = game.assets;

    /** @type {Object<string,MadnesAudio>} */
    this._sounds = game.sounds;

    /** @type {ResultController} */
    this._resultController = resultController;

    /** @type {SpinReels} */
    this._reels = game.spinReels;

    /** @type {Function|null} */
    this._resolver;

    /** @type {ServerResultWinline} */
    this._winline;

    /** @type {Array<ServerResultWinline>} */
    this._winlines;

    /** @type {SymbolsManager} */
    this._symbolsManager = symbolsManager;

    /** @type {ServerResultWinline|undefined} */
    this.nextWinLine;

    /** @type {ServerResult} */
    this._serverResult = serverResult;
}

WinControl.prototype.init = function() {
    return new Promise(function(res) {
        this._resolver = res;
    }.bind(this));
};

/**
 * @param {ServerResultWinline} winline
 */
WinControl.prototype._playWinlineSound = function(winline) {

    var audioName = "win_low";
    if (winline.getSymbol() <= 2)
    {
        audioName = "win_high";
    }

    audioName += "_" + this._calcWinAudioPos();

    this._sounds[audioName].play();
};

WinControl.prototype._calcWinAudioPos = function() {
    if(this._resultController.winAudioPos % 4 === 0) {
        return 4;
    }

    return this._resultController.winAudioPos % 4;
};

/**
 * @param {ServerResultWinline|undefined} winline
 */
WinControl.prototype.setNextWinLine = function(winline) {
    this.nextWinLine = winline;
};

/**
 *
 * @returns {number}
 */
WinControl.prototype._incControlResultPos = function() {
    //console.log('inc', this._resultController._controlResultPos + 1);
    return this._resultController.incControlResultPos();
};

/**
 * @param {string} headerType
 * @returns {Promise}
 */
WinControl.prototype._onWinlineEnd = function(headerType) {
    var _self = this;

//	if(!headerType) {
//		throw new Error("missing header type");
//	}

    return new Promise(function(res) {

        if(_self.nextWinLine) {
            res();
            return;
        }

        var anims = [];

        if(!_self._game.bonus.inBonus()) {
            anims.push(_self._assets.header.show("logo"));
        } else {
            anims.push(_self._assets.header.show("bonus"));
        }

        anims.push(_self._assets.fadeOutBlackScreen());
        Promise.all(anims).then(res);
    });
};

WinControl.prototype._addWin = function(win) {
    if(win) {
        this._game.addWin(win * 1);
    }
};

/**
 * @param {ServerResultWinline} winline
 * @param {Array<ServerResultWinline>} winlines All winlines
 */
WinControl.prototype.run = function(winline, winlines) {

    var _self = this;

    if(!this._resolver) throw new Error("resolver not set!! call init() first");

    this._winline = winline;
    this._winlines = winlines;

    var winType = this._winline.getType();


    if((winType === "normal" || winType === "wild") && _self._isSkip()) {
        winType = "_skip";
    }

    if(this._resultController.isBigWin()) {
        winType = "_bigwin";
    }

    _self._runWinType(winType);

};

/**
 * @param {string=} winType
 */
WinControl.prototype._runWinType = function(winType) {

    switch(winType) {

        case "normal":

            this._controlNormal();
            break;

        case "wild":

            this._controlNormal();
            break;

        case "scatter":

            this._controlScatter();
            break;

        case "_skip":

            this._controlSkip();
            break;

        case "_bigwin":

            this._controlBigwin();
            break;

        default:
            console.warn("winline type not defined");
//			this._resolver();
            break;
    }
};

/**
 * @returns {boolean}
 */
WinControl.prototype._isSkip = function() {
    return MI.controls.winAnimSkip();
//	return MI.controls.winAnimSkipClicked();
};

WinControl.prototype._controlSkip = function() {

    var _self = this;
    this._addWin(this._winline.getWin());

    this._onWinlineEnd("").then(function() {
        _self._resolver();
    });
};

/**
 * @returns {undefined}
 */
WinControl.prototype._controlNormal = function() {

    this._game.memory.reinit(this._serverResult);

    var _self = this;
    var won = this._winline.getWin();

    this._addWin(won);

    var resSymbols = this._getResSymbols(this._winline.getPosition());
    var animsSymbols = this._symbolsManager.createAnimsSymbols(resSymbols, null);

    var anim;
    var anims = [];

    for(var i = 0; i < animsSymbols.length; i++) {

        var reelX = animsSymbols[i].getReelX();
        var group = this._groups.get("group_symbols_anims_" + reelX);
        group.add(animsSymbols[i]);

        animsSymbols[i].createSymbol();
        animsSymbols[i].setVisible(true);
        resSymbols[i].setVisible(false);
    }

    this._assets.fadeInBlackScreen();

    this._assets.header.show("lines").then(function() {

        _self._assets.header.lines.animWinLine(_self._winline);

    });

    anim = this._assets.lightCoverFadeIn();
    anims.push(anim);

    if(this._game.bonus.inBonus()) {

        var bonusReelLeft = this._game.bonus.getBonusReel("left");
        bonusReelLeft.pause();

        this._symbolWinAnim(bonusReelLeft.sparkle, 0.845).then(function() {
            bonusReelLeft.resume();
        });
        this._symbolWinAnim(bonusReelLeft.smoke, 0.845);

        if(this._game.bonus.getBonusType() === "double") {

            var bonusReelRight = this._game.bonus.getBonusReel("right");
            bonusReelRight.pause();

            this._symbolWinAnim(bonusReelRight.sparkle, 0.845).then(function() {
                bonusReelRight.resume();
            });
            this._symbolWinAnim(bonusReelRight.smoke, 0.845);
        }
    }

    this._playWinlineSound(this._winline);

    this._resultController.winAudioPos++;

    for(var i = 0; i < animsSymbols.length; i++) {
        anim = _self._symbolWinAnim(animsSymbols[i]);
        anims.push(anim);
    }

    anim = _self._assets.animWinLines([_self._winline]);
    anims.push(anim);

    _self._assets.playParticles(animsSymbols, 80, this._groups);

    //_self._assets.coinsEmitter.hideCoins();

    MI.createTimer().add(function() {
        _self._assets.coinsEmitter.winPlay();
        //_self._assets.coinsEmitter.showCoins();
    }, 100);

    _self._assets.animWinCounter.init();

    var time = 450;
//	if (MI.moneyToCoin(won) <= 5) {
//		//time = 150;
//	}

    if (this._winline.getSymbol() <= 2) {
        time += 300;
    }

    anim = _self._assets.animWinCounter.run(MI.moneyToCoin(won), time).then(function() {

        _self._assets.coinsEmitter.winStop();

    });
    anims.push(anim);

    Promise.all(anims).then(function() {

        _self._assets.animWinCounter.hide();

        for(var i = 0; i < animsSymbols.length; i++) {
            animsSymbols[i].destroy();
            resSymbols[i].setVisible(true);
        }

        _self._assets.header.lines.hideAllLights();
        _self._assets.hideWinLines();

        _self._assets.lightCoverFadeOut();

        return _self._onWinlineEnd("");
    }).then(function() {
        _self._resolver();
    });
};

WinControl.prototype._controlScatter = function() {

    this._game.memory.reinit(this._serverResult);

    var _self = this;

    MI.controls.hideAllBtns();

    var resSymbols = this._getResSymbols(this._winline.getPosition());
    var animsSymbols = this._symbolsManager.createAnimsSymbols(resSymbols, null);

    for(var i = 0; i < animsSymbols.length; i++) {

        var reelX = animsSymbols[i].getReelX();
        var group = this._groups.get("group_symbols_anims_" + reelX);

        group.add(animsSymbols[i]);
        animsSymbols[i].createSymbol();
        animsSymbols[i].setVisible(true);
        resSymbols[i].setVisible(false);
    }

    this._assets.fadeInBlackScreen();

    this._assets.header.show("lines").then(function() {

        _self._assets.header.lines.animWinLine(_self._winline);

    });

    _self._assets.playParticles(animsSymbols, 80, this._groups);
    var boomSpinsAnim = _self._assets.boomSpins.play(_self._winline.getPosition().length);

    this._sounds["win_stars"].play();

    var anim;
    var anims = [];

    for(var i = 0; i < animsSymbols.length; i++) {
        anim = _self._symbolWinAnim(animsSymbols[i]);
        anims.push(anim);
    }

    Promise.all(anims).then(function() {

        // for(var i = 0; i < animsSymbols.length; i++) {
        // 	animsSymbols[i].destroy();
        // 	resSymbols[i].setVisible(true);
        // }

        _self._assets.header.show(_self._game.bonus.inBonus() ? "bonus" : "logo");
    });

    boomSpinsAnim.then(function() {

        _self._game.memory.reinit(_self._serverResult);

        _self._assets.fadeOutBlackScreen();

        for(var i = 0; i < animsSymbols.length; i++) {
            animsSymbols[i].destroy();
            resSymbols[i].setVisible(true);
        }

        //_self._assets.boomSpins.hide(selectedOption);

        return _self._game.bonus.enterBonus();
    }).then(function() {

        _self._resolver();

    });

// 	_self._assets.boomSpins.setOnChoose(function(selectedOption) {
//
// 		var data = { 'freeSpinChoice': selectedOption.getPickIndex() };
//
// 		var pick = MI.server.playersPick(0, data);
// 		var hide = _self._assets.boomSpins.hide(selectedOption);/*.then(function() {
// //			_self._game.bonus.enterBonus();
// 		});*/
//
// 		MI.createTimer().add(function() {
// 			_self._assets.fadeOutBlackScreen();
// 		}, 2500);
//
// 		Promise.all([pick, hide]).then(function() {
//
// 			_self._serverResult.init(MI.server.getPlayersPick());
// 			_self._game.memory.reinit(_self._serverResult);
//
// 			return _self._game.bonus.enterBonus();
//
// 		}).then(function() {
//
// 			return _self._onWinlineEnd("");
//
// 		}).then(function() {
// 			_self._resolver();
// 		});
// 	});
};

WinControl.prototype._controlBigwin = function() {

    var _self = this;

    this._game.memory.reinit(this._serverResult);

    var won = 0;

    for(var i = 0; i < _self._winlines.length; i++) {
        won += _self._winlines[i].getWin();
    }

    var resSymbols = this._getAllWinSymbols();
    var animsSymbols = this._symbolsManager.createAnimsSymbols(resSymbols, null);

    for(var i = 0; i < animsSymbols.length; i++) {

        var reelX = animsSymbols[i].getReelX();
        var group = this._groups.get("group_symbols_anims_" + reelX);

        group.add(animsSymbols[i]);
        animsSymbols[i].createSymbol();
        animsSymbols[i].setVisible(true);
        resSymbols[i].setVisible(false);

        this._symbolWinAnim(animsSymbols[i]);
    }

    var headerType = this._assets.header.getType();
    this._assets.header.show("lines").then(function() {

        _self._assets.header.lines.animDrawLinesBigWin(_self._winlines);

    });

    this._assets.animWinLines(this._winlines);

    this._assets.bigWin.reinit();

    this._assets.bigWin.setOnPulseStart(function() {
        _self._addWin(won);
    });

    this._assets.bigWin.run(won, animsSymbols).then(function() {

        _self._assets.header.lines.stopAnimLinesBigWin();

        for(var i = 0; i < animsSymbols.length; i++) {
            animsSymbols[i].destroy();
            resSymbols[i].setVisible(true);
        }

        return _self._assets.header.show(headerType);

    }).then(function() {

        _self._resolver({ "fromBigWin": true });

    });


};

/**
 * @param {MadnesObject} symbol
 * @param {number=} c
 */
WinControl.prototype._symbolWinAnim = function(symbol, c) {

    if(typeof c === "undefined") { c = 1; }

    return new Promise(function(res) {

        MI.addTween().to(symbol, { 'x': 1.42 * c, 'y': 1.42 * c }, {
            'scale': true,
            'duration': 380,
            'easing': MadnesTween.getEasing("cubic_out"),
            'callback': function() {

                MI.addTween().to(symbol, { 'x': 1.06 * c, 'y': 1.06 * c }, {
                    'scale': true,
                    'duration': 200,
//					'easing': MadnesTween.getEasing("cubic_in"),
                    'callback': function() {

                        MI.addTween().to(symbol, { 'x': 1.2 * c, 'y': 1.2 * c }, {
                            'scale': true,
                            'duration': 300,
                            'easing': MadnesTween.getEasing("cubic_out"),
                            'callback': function() {

                                MI.addTween().to(symbol, { 'x': 1, 'y': 1 }, {
                                    'scale': true,
                                    'duration': 200,
//									'easing': MadnesTween.getEasing("cubic_in"),
                                    'callback': res
                                });
                            }
                        });
                    }
                });
            }
        });
    });
};

WinControl.prototype._isNextShowSymbols = function() {

    if(!this.nextWinLine)
    {
        return false;
    }

    return this.nextWinLine.getType() === "showSymbols";
};

/**
 * @param {Array<AbstractSymbol>} symbols
 * @returns {Array<AbstractSymbol>}
 */
WinControl.prototype._getWildSymbols = function(symbols) {
    var wilds = [];
    for(var i = 0; i < symbols.length; i++) {

        var reelX = symbols[i].getReelX();
        if(this._reels.getReel(reelX).spreaded) {
            wilds.push(symbols[i]);
        }
    }
    return wilds;
};

/**
 * @param {Array} positions
 * @returns {Array<AbstractSymbol>}
 */
WinControl.prototype._getResSymbols = function(positions) {
    return this._reels.getResSymbols(positions);
};

/**
 * @returns {Array<AbstractSymbol>}
 */
WinControl.prototype._getAllWinSymbols = function() {

    var symbols = [];

    for(var i = 0; i < this._winlines.length; i++) {

        var resSymbols = this._reels.getResSymbols(this._winlines[i].getPosition());

        for(var j = 0; j < resSymbols.length; j++) {
            if(symbols.indexOf(resSymbols[j]) === -1) {
                symbols.push(resSymbols[j]);
            }
        }
    }

    return symbols;
};

WinControl.prototype._animWinSkip = function(winText, callback) {
    var _self = this;

    MI.addTween().to(winText, { 'alpha': 1 }, {
        'duration': 150
    });

    MI.createTimer().add(function() {
        _self._sounds["misc_Coin_Drop_" + getRandomInt(1, 5)].play();
    }, 200);

    MI.addTween().to(winText, { 'x': 1, 'y': 1 }, {
        'scale': true,
        'duration': 250,
        'onStart': function() {
            winText.setVisible(true);
        },
        'callback': function() {
            MI.addTween().to(winText, { 'alpha': 0 }, {
                'delay': 125,
                'duration': 100,
                'callback': callback
            });
        }
    });

};

/** @returns {Promise} */
WinControl.prototype.end = function() {

    return new Promise(function(res) {

//		this._reels.fadeOutBlackScreen().then(res);

        res();

    }.bind(this));
};